export interface IUserMessage {
  type: UserMessageType;
  title?: string;
  message: string;
  detail?: string;  
  hideClose?: boolean;
  handleCancel?: () => Promise<void>;
  handleRetry?: () => Promise<void>;
}

export enum UserMessageType {
  Error = 1,
  Warning,
  Info,
  Alert,
  Custom
}

export class UserMessages {
  public static readonly UNEXPECTED_ERROR = "An unexpected error occurred.";
  public static readonly ERROR_OPENING_PAGE = "An error occurred while opening the page.";
  public static readonly ERROR_WHILE_LOGIN = "An error occurred while signing in.";
  public static readonly ERROR_LOADING_CARD = "An error occurred while loading card.";
}
